export default "__VITE_ASSET__b18f2d7c__"